// examName comes straight from Branding#exam_name. The IELTS General Training branding's
// name carries a trailing space in production, so always compare against the trimmed name.
export const isIELTSExamName = (examName: string) => {
  const trimmed = (examName || '').trim();
  return trimmed === 'IELTS' || trimmed === 'IELTS General Training';
};
